module.exports = __webpack_public_path__ + "img/admin.c9f7f340.png";